import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Quote } from "lucide-react";

const Card = ({ name, role, quote, accent }) => (
  <div className="shrink-0 w-[320px] sm:w-[380px] bg-white border border-blue-900/10 rounded-2xl p-6 shadow-sm">
    <Quote size={28} className="text-amber-500/70" />
    <p className="mt-3 text-[15px] leading-relaxed text-slate-700">
      &ldquo;{quote}&rdquo;
    </p>
    <div className="mt-5 flex items-center gap-3">
      <div
        className="h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm"
        style={{ background: accent }}
      >
        {name.charAt(0)}
      </div>
      <div className="leading-tight">
        <p className="font-bold text-blue-950 text-sm">{name}</p>
        <p className="text-xs text-slate-500">{role}</p>
      </div>
    </div>
  </div>
);

const ACCENTS = [
  "#1E3A8A",
  "#991B1B",
  "#0F766E",
  "#C2410C",
  "#7C3AED",
  "#0369A1",
];

const Testimonials = () => {
  const { t } = useLanguage();
  const items = [...t.testimonials.items, ...t.testimonials.items];
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 text-center">
        <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
          {t.testimonials.eyebrow}
        </span>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.05] max-w-3xl mx-auto">
          {t.testimonials.title}
        </h2>
      </div>

      <div className="mt-14 marquee">
        <div className="marquee-track">
          {items.map((it, i) => (
            <Card
              key={`a-${i}`}
              {...it}
              accent={ACCENTS[i % ACCENTS.length]}
            />
          ))}
        </div>
        <div className="marquee-track" aria-hidden>
          {items.map((it, i) => (
            <Card
              key={`b-${i}`}
              {...it}
              accent={ACCENTS[i % ACCENTS.length]}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
